import api_json from "./api.json";

export function schema_api() {
	return api_json;
}
